import React from 'react';
import Dialog from 'react-toolbox/lib/dialog';
import { IconButton } from 'react-toolbox/lib/button';
import style from './style.scss';

export default props => (
  <Dialog {...props}>
    {props.onCloseButtonClick && (
      <div className={style.close}>
        <IconButton icon="close" onClick={props.onCloseButtonClick} />
      </div>
    )}
    {props.children}
  </Dialog>
);



// WEBPACK FOOTER //
// ./app/components/Dialog/index.js